export const translations = {
  en: {
    // Navigation
    about: 'About',
    experience: 'Experience',
    work: 'Work',
    contact: 'Contact',
    resume: 'Resume',

    // Hero Section
    greeting: 'Hi, my name is',
    name: 'Y Lau.',
    tagline: 'I create interesting things for the online world.',
    description:
      'I am an Internet Product Manager, focused on creating engaging digital experiences (occasionally developing applications). Currently, I am dedicated to building exceptional products in the Web3 space.',
    //company: 'Upstatement',
    cta: 'Check out my Application!',

    // About Section
    aboutTitle: 'About Me',
    aboutParagraph1:
      'Hello! My name is Liu Yu, and I enjoy creating interesting things on the internet. My interest in the internet began in 2011 when I, along with three classmates, developed an online travel data service platform. During the three years of running the company, we launched a travel platform and overseas social applications, gaining a lot of foundational knowledge and operational experience in internet products!',
    aboutParagraph2:
      'Fast forward to today, I am now a full-time Product Manager at a Web3 internet company. My current focus is on iterating the operations of a blockchain payment gateway project, providing users with an inclusive and ultra-fast payment experience.',
    aboutParagraph3:
      'In my spare time, I create self-media content related to public API service development, covering Web3, hardware development, and sharing the process of building.',
    aboutParagraph4: 'Here are a few technologies I\'ve been working with recently:',

    // Jobs Section
    jobsTitle: 'Where I\'ve Worked',

    // Projects Section
    projectsTitle: 'Some Things I\'ve Built',
    featuredTitle: 'Featured Project',
    featuredSectionTitle: 'Some Things I\'ve Built',
    otherProjects: 'My Blog',
    viewMyBlog: 'view the MyBlog',
    updating: 'Updating...',
    showMore: 'Show More',
    showLess: 'Show Less',

    // Contact Section
    contactTitle: 'What\'s Next?',
    contactSubtitle: 'Get In Touch',
    contactDescription:
      'Although I\'m not currently looking for any new opportunities, my inbox is always open. Whether you have a question or just want to say hi, I\'ll try my best to get back to you!',
    sayHello: 'Say Hello',

    // Footer
    builtBy: '@2025 ID8',

    // MyBlog Page
    MyBlogTitle: 'My Blog',
    MyBlogSubtitle: 'Recording interesting voices, please like and share if you enjoy my articles',
    year: 'Year',
    project: 'Project',
    madeAt: 'Made at',
    builtWith: 'Built with',
    link: 'Link',

    // Pensieve (Blog)
    pensieveTitle: 'Pensieve',
    pensieveSubtitle: 'a collection of memories',
    allPosts: 'All Posts',
    readNow: 'Read Now',

    // Blog Page
    blogTitle: 'Blog',
    blogSubtitle: 'Thoughts, stories and ideas',
    featuredPost: 'Featured Post',
    latestPosts: 'Latest Posts',
    latestPost: 'Latest Post',
    readMore: 'Read More',
    publishedOn: 'Published on',
    tags: 'Tags',
    noPostsFound: 'No posts found',
    loadingPosts: 'Loading posts...',
    errorLoadingPosts: 'Error loading posts',
    retry: 'Retry',
    previousPage: 'Previous',
    nextPage: 'Next',
    page: 'Page',
    of: 'of',
    socialShare: 'Share on social media',
    backToBlogList: 'Back to Blog List',
    wechatQRCode: 'WeChat QR Code',
    scanToAddWeChat: 'Scan to add WeChat',
    allArticles: 'All Articles',
    tableOfContents: 'Table of Contents',
    advertisement: 'Advertisement',
    advertisementSpace: 'Advertisement Space',
    supportAuthor: 'Support Author',
    donationQRCode: 'Donation QR Code',
    scanToDonate: 'Scan to donate',
    readTime: 'Read time',
    minutes: 'min',
    shareArticle: 'Share Article',
    systemShare: 'System Share',
    shareToTwitter: 'Share to X (Twitter)',
    shareToTelegram: 'Share to Telegram',
    shareToWeChat: 'Share to WeChat',
    copyLink: 'Copy Link',
    linkCopied: 'Link copied to clipboard',
    wechatShareTip:
      'Please click the menu button in the top right corner to share to Moments or send to friends',
    defaultDescription: 'Click to read more...',
    previousArticle: 'Previous Article',
    nextArticle: 'Next Article',

    // Application Page
    applicationTitle: 'Application List',
    applicationSubtitle:
      'The following applications are mainly used for learning and communication, including but not limited to open source, commercial use is not allowed, please read the repository open source license carefully',
    title: 'Title',
    category: 'Category',

    // 404 Page
    notFoundTitle: 'Page Not Found',
    notFoundDescription: 'The page you are looking for does not exist.',
    goHome: 'Go Home',

    // Resume Page
    resumeTitle: 'Resume',
    resumeLoading: 'Loading resume...',
    resumeLoadError: 'Failed to load',
    resumeLoadErrorDesc: 'Unable to load resume content',
    downloadResume: 'Download Resume',
    downloadPDF: 'Download PDF',
    downloadWord: 'Download Word',
    downloadPNG: 'Download PNG',
    downloadOptions: 'Download Options',
    buyMeACoffee: 'Buy Me a Coffee',
  },

  'zh-CN': {
    // Navigation
    about: '关于我',
    experience: '工作经历',
    work: '作品集',
    contact: '联系我',
    resume: '简历',

    // Hero Section
    greeting: '嗨，我的名字是',
    name: '刘宇.',
    tagline: '我为网络世界创造有趣事物',
    description:
      '我是一名互联网产品经理，专注于创造有趣的互联事务（偶尔开发应用），目前专注于web3领域打造卓越的产品',
    //company: 'Upstatement',
    cta: '查看我的应用！',

    // About Section
    aboutTitle: '关于我',
    aboutParagraph1:
      '你好！我的名字是刘宇，我喜欢创造互联网上的有趣事物，我对互联网的兴趣始于2011年，当时我和三个同学一起开发了一个在线旅游的数据服务供应平台，在公司经营的三年中我们上线了旅游平台，海外社交应用，积累了很多互联网产品基础知识与运营经验！',
    aboutParagraph2:
      '快进到今天，我已经是一名全职产品经理，就职于一家web3互联网公司。我目前的主要重点是在运营迭代一款区块链支付网关项目，为用户提供包容性与极速体验的支付体验产品。',
    aboutParagraph3:
      '业余时间，我会做一些自媒体关于公共api服务开发，涵盖web3，硬件开发，建造过程分享。',
    aboutParagraph4: '以下是我最近使用的一些技术：',

    // Jobs Section
    jobsTitle: '我的工作经历',

    // Projects Section
    projectsTitle: '我构建的一些作品',
    featuredTitle: '精选项目',
    featuredSectionTitle: '我构建的一些项目',
    otherProjects: '我的博客',
    viewMyBlog: '查看我的博客',
    updating: '更新中...',
    showMore: '显示更多',
    showLess: '显示更少',

    // Contact Section
    contactTitle: '接下来呢？',
    contactSubtitle: '与我联系',
    contactDescription:
      '虽然我目前没有在寻找新的机会，但我的收件箱永远是开放的。无论你有问题还是只是想打个招呼，我都会尽力回复你！',
    sayHello: '打声招呼',

    // Footer
    builtBy: '@2025 ID8',

    // MyBlog Page
    MyBlogTitle: '我的博客',
    MyBlogSubtitle: '记录有趣的声音，如果你喜欢我的文章请为我点赞分享',
    year: '年份',
    project: '项目',
    madeAt: '制作于',
    builtWith: '使用技术',
    link: '链接',

    // Pensieve (Blog)
    pensieveTitle: '冥想盆',
    pensieveSubtitle: '记忆的收藏',
    allPosts: '所有文章',
    readNow: '立即阅读',

    // Blog Page
    blogTitle: '博客',
    blogSubtitle: '思考、故事和想法',
    featuredPost: '精选文章',
    latestPosts: '最新文章',
    latestPost: '最新文章',
    readMore: '阅读更多',
    publishedOn: '发布于',
    tags: '标签',
    noPostsFound: '未找到文章',
    loadingPosts: '加载文章中...',
    errorLoadingPosts: '加载文章失败',
    retry: '重试',
    previousPage: '上一页',
    nextPage: '下一页',
    page: '第',
    of: '页，共',
    socialShare: '分享到社交媒体',
    backToBlogList: '返回博客列表',
    wechatQRCode: '微信二维码',
    scanToAddWeChat: '扫码添加微信',
    allArticles: '所有文章',
    tableOfContents: '目录',
    advertisement: '广告',
    advertisementSpace: '广告位',
    supportAuthor: '支持作者',
    donationQRCode: '打赏二维码',
    scanToDonate: '扫码打赏',
    readTime: '阅读时间',
    minutes: '分钟',
    shareArticle: '分享文章',
    systemShare: '系统分享',
    shareToTwitter: '分享到 X (Twitter)',
    shareToTelegram: '分享到 Telegram',
    shareToWeChat: '分享到微信',
    copyLink: '复制链接',
    linkCopied: '链接已复制到剪贴板',
    wechatShareTip: '请点击右上角菜单按钮分享到朋友圈或发送给朋友',
    defaultDescription: '点击阅读更多...',
    previousArticle: '上一篇',
    nextArticle: '下一篇',

    // Application Page
    applicationTitle: '应用列表',
    applicationSubtitle:
      '以下应用主要用于学习交流，包括不限于开源不允许商业用途，请仔细阅读仓库开源许可',
    title: '标题',
    category: '分类',

    // 404 Page
    notFoundTitle: '找不到页面',
    notFoundDescription: '您寻找的页面不存在。',
    goHome: '回到首页',

    // Resume Page
    resumeTitle: '简历',
    resumeLoading: '加载简历中...',
    resumeLoadError: '加载失败',
    resumeLoadErrorDesc: '无法加载简历内容',
    downloadResume: '下载简历',
    downloadPDF: '下载PDF',
    downloadWord: '下载Word',
    downloadPNG: '下载PNG',
    downloadOptions: '下载选项',
    buyMeACoffee: '请我喝咖啡',
  },

  'zh-TW': {
    // Navigation
    about: '關於我',
    experience: '工作經歷',
    work: '作品集',
    contact: '聯絡我',
    resume: '履歷',

    // Hero Section
    greeting: '嗨，我的名字是',
    name: '劉宇.',
    tagline: '我為網路世界創造有趣事物',
    description:
      '我是一名互聯網產品經理，專注於創造有趣的互聯事務（偶爾開發應用），目前專注於web3領域打造卓越的產品',
    //company: 'Upstatement',
    cta: '查看我的應用！',

    // About Section
    aboutTitle: '關於我',
    aboutParagraph1:
      '你好！ 我的名字是劉宇，我喜歡創造互聯網上的有趣事物，我對互聯網的興趣始於2011年，當時我和三個同學一起開發了一個在線旅遊的數據服務供應平台，在公司經營的三年中我们上線了旅遊平台，海外社交應用，積累了很多互聯網產品基礎知識與運營經驗！',
    aboutParagraph2:
      '快進到今天，我已經是一名全職產品經理，就職於一家web3互聯網公司。我目前的主要重點是在運營迭代一款區塊鏈支付網關項目，為用戶提供包容性與極速體驗的支付體驗產品。',
    aboutParagraph3:
      '業餘時間，我會做一些自媒體關於公共api服務開發，涵蓋web3，硬件開發，建造過程分享。',
    aboutParagraph4: '以下是我最近使用的一些技術：',

    // Jobs Section
    jobsTitle: '我的工作經歷',

    // Projects Section
    projectsTitle: '我建構的一些作品',
    featuredTitle: '精選專案',
    featuredSectionTitle: '我構建的一些專案',
    otherProjects: '我的博客',
    viewMyBlog: '查看檔案庫',
    updating: '更新中...',
    showMore: '顯示更多',
    showLess: '顯示較少',

    // Contact Section
    contactTitle: '接下來呢？',
    contactSubtitle: '與我聯絡',
    contactDescription:
      '雖然我目前沒有在尋找新的機會，但我的收件匣永遠是開放的。無論你有問題還是只是想打個招呼，我都會盡力回覆你！',
    sayHello: '打聲招呼',

    // Footer
    builtBy: '@2025 ID8',

    // MyBlog Page
    MyBlogTitle: '我的博客',
    MyBlogSubtitle: '記錄有趣的聲音，如果你喜歡我的文章請為我點讚分享',
    year: '年份',
    project: '專案',
    madeAt: '製作於',
    builtWith: '使用技術',
    link: '連結',

    // Pensieve (Blog)
    pensieveTitle: '冥想盆',
    pensieveSubtitle: '記憶的收藏',
    allPosts: '所有文章',
    readNow: '立即閱讀',

    // Blog Page
    blogTitle: '博客',
    blogSubtitle: '思考、故事和想法',
    featuredPost: '精選文章',
    latestPosts: '最新文章',
    latestPost: '最新文章',
    readMore: '閱讀更多',
    publishedOn: '發布於',
    tags: '標籤',
    noPostsFound: '未找到文章',
    loadingPosts: '載入文章中...',
    errorLoadingPosts: '載入文章失敗',
    retry: '重試',
    previousPage: '上一頁',
    nextPage: '下一頁',
    page: '第',
    of: '頁，共',
    socialShare: '分享到社交媒體',
    backToBlogList: '返回博客列表',
    wechatQRCode: '微信二維碼',
    scanToAddWeChat: '掃碼添加微信',
    allArticles: '所有文章',
    tableOfContents: '目錄',
    advertisement: '廣告',
    advertisementSpace: '廣告位',
    supportAuthor: '支持作者',
    donationQRCode: '打賞二維碼',
    scanToDonate: '掃碼打賞',
    readTime: '閱讀時間',
    minutes: '分鐘',
    shareArticle: '分享文章',
    systemShare: '系統分享',
    shareToTwitter: '分享到 X (Twitter)',
    shareToTelegram: '分享到 Telegram',
    shareToWeChat: '分享到微信',
    copyLink: '複製連結',
    linkCopied: '連結已複製到剪貼簿',
    wechatShareTip: '請點擊右上角選單按鈕分享到朋友圈或發送給朋友',
    defaultDescription: '點擊閱讀更多...',
    previousArticle: '上一篇',
    nextArticle: '下一篇',

    // Application Page
    applicationTitle: '應用列表',
    applicationSubtitle:
      '以下應用主要用於學習交流，包括不限於開源不允許商業用途，請仔細閱讀倉庫開源許可',
    title: '標題',
    category: '分類',

    // 404 Page
    notFoundTitle: '找不到頁面',
    notFoundDescription: '您尋找的頁面不存在。',
    goHome: '回到首頁',

    // Resume Page
    resumeTitle: '履歷',
    resumeLoading: '載入履歷中...',
    resumeLoadError: '載入失敗',
    resumeLoadErrorDesc: '無法載入履歷內容',
    downloadResume: '下載履歷',
    downloadPDF: '下載PDF',
    downloadWord: '下載Word',
    downloadPNG: '下載PNG',
    downloadOptions: '下載選項',
    buyMeACoffee: '請我喝咖啡',
  },
};

export const defaultLanguage = 'en';
export const languages = ['en', 'zh-CN', 'zh-TW'];

export const getTranslation = (key, language = defaultLanguage) =>
  translations[language]?.[key] || translations[defaultLanguage]?.[key] || key;
